import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './AuthContext';
import Login from './components/Login';
import Signup from './components/Signup';
import Profile from './components/Profile';
import Main from './components/Main';
import EditProfile from './components/EditProfile';
import TermsOfUse from './components/TermsOfUse';
import PrivacyPolicy from './components/PrivacyPolicy';
import LearnMore from './components/LearnMore';
import SuccessScreen from './components/stripe/Success';
import Subscription from './components/stripe/Subscription';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword.js'; 


function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Main />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/edit-profile" element={<EditProfile />} />
          <Route path="/terms-of-use" element={<TermsOfUse />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/learn-more" element={<LearnMore />} />
          <Route path="/success" element={<SuccessScreen />} />
          <Route path="/subscription" element={<Subscription />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          {/* Add other routes */}
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
